export default "__VITE_PUBLIC_ASSET__93e55018__"